/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_How_TitleInputs */

const en_seo_how_title = /** @type {(inputs: Seo_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works for trainers`)
};

const pl_seo_how_title = /** @type {(inputs: Seo_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak to działa dla trenerów`)
};

/**
* | output |
* | --- |
* | "How it works for trainers" |
*
* @param {Seo_How_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_how_title = /** @type {((inputs?: Seo_How_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_How_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_how_title(inputs)
	return en_seo_how_title(inputs)
});